/**
 * コンテンツデータ編集画面において現在のコンテンツタイプの情報を取得します。
 *
 * @returns {object|undefined} - コンテンツタイプ
 */
export function getCurrentContentType() {
    const mtappVars = window.mtappVars;
    if (mtappVars.screen_id !== 'edit-content-type-data') {
        return undefined;
    }
    if (typeof mtappVars.blog_id === 'undefined') {
        throw new Error('mtappVars.blog_id is undefined.');
    } else if (typeof mtappVars.content_type_id === 'undefined') {
        throw new Error('mtappVars.content_type_id is undefined.');
    } else if (typeof mtappVars.contentTypes === 'undefined') {
        throw new Error('mtappVars.contentTypes is undefined.');
    } else if (!Array.isArray(mtappVars.contentTypes)) {
        throw new Error('mtappVars.contentTypes is not array.');
    }
    const siteId = Number(mtappVars.blog_id);
    const contentTypeId = Number(mtappVars.content_type_id);

    return mtappVars.contentTypes.find((contentType) => {
        return contentType.id === contentTypeId && contentType.site_id === siteId;
    });
}
